const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyBcWL0m4qgy-Trl8z91qf7UI7783P_jSAk",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "connect-plus-4884a.firebaseapp.com",
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://connect-plus-4884a.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "connect-plus-4884a",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "connect-plus-4884a.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "887683481993",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:887683481993:web:479c1409c2ef6eda74e158",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-1FYVW2SQ6E",
};

export default firebaseConfig;

export const firebaseAPI = "https://ur-api-vhdl4b2wya-uc.a.run.app";
// export const firebaseAPI = "http://localhost:5000";
// export const firebaseAPI =
//   "https://us-central1-connect-plus-4884a.cloudfunctions.net/ur_api";
